var NubeDePalabras = function(el, datos, total, callback) {
  var debug = false;
  var config = new Config(500, { top: 10, right: 10, bottom: 10, left: 10 });

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var circulos = config.getCirculos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;
  var gPalabras = null;

  var escalaX = d3.scale.linear().range([20, 80]);
  var escalaOpacidad = d3.scale.linear().range([0.3, 1]);

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }
      gPalabras = gGrafica.append("g");

      var n = datos.palabras.length;
      datos.palabras = _.map(datos.palabras, function(p, i) {
        return { key: p, value: n - i };
      });
      setPalabras();
    }
  }

  function main() {
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
  }

  function revisaScroll() {
    if (debug === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    } else {
      if (el.visible() === true) {
        iniciar();
        $(window).off("scroll", revisaScroll);
      }
    }
  }

  function iniciar() {
    actualizapalabras();
    callback(null, true);
  }

  function actualizapalabras() {
    gPalabras
      .selectAll("text")
      .transition()
      .duration(800)
      .attr("opacity", function(d) {
        return escalaOpacidad(d.value);
      });
  }

  function setPalabras() {
    var escala = 2.5;
    var transportes = config.getTransportes();
    var nube = config.getNube();

    var max = d3.max(datos.palabras, function(d) {
      return d.value;
    });
    escalaX.domain([0, max]);
    escalaOpacidad.domain([0, max]);

    d3.layout
      .cloud()
      .size([(gMedidas.ancho * 3) / 4, (gMedidas.alto * 3) / 4])
      .timeInterval(20)
      .words(datos.palabras)
      .fontSize(function(d) {
        return escalaX(+d.value);
      })
      .text(function(d) {
        return d.key;
      })
      .rotate(function() {
        return ~~(Math.random() * 2) * 90;
      })
      .font(nube.fuente)
      .on("end", draw)
      .start();

    function draw(palabras) {
      gPalabras
        .selectAll("text")
        .data(palabras)
        .enter()
        .append("text")
        .style("font-size", function(d) {
          return escalaX(d.value) + "px";
        })
        .style("font-family", nube.familia)
        .style("fill", nube.fill)
        .attr("text-anchor", "middle")
        .attr("transform", function(d) {
          return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
        })
        .attr("opacity", 0)
        .text(function(d) {
          return d.key;
        });

      var caja = gPalabras.node().getBBox();
      var offsetX = (gMedidas.ancho - caja.width) / 2;
      gPalabras.attr(
        "transform",
        "translate(" + [-caja.x + offsetX, -caja.y] + ")"
      );
      main();
    }

    d3.layout.cloud().stop();

    gGrafica
      .append("path")
      .datum(datos)
      .attr("class", "transporte")
      .attr("d", function(d) {
        return d.ruta;
      })
      .attr("transform", "scale(" + escala + ")")
      .attr("fill", transportes.fondo)
      .each(function(d) {
        var caja = this.getBBox();
        d.caja = caja;
        d.offset = { x: 0, y: 0 };
        d.offset.x = (gMedidas.ancho - d.caja.width * escala) / 2;
        d.offset.y = gMedidas.alto - d.caja.height * escala;
      })
      .attr("transform", function(d) {
        return (
          "translate(" +
          [-d.caja.x * escala + d.offset.x, -d.caja.y * escala + d.offset.y] +
          ")scale(" +
          escala +
          ")"
        );
      });
  }

  setup();
};
